import { useStore } from 'vuex';
import { computed } from 'vue';
import { StateInterface } from '../store/index';
import Mapboxgl from 'mapbox-gl';
import { Feature } from '@/interfaces/places';
import { lngLat } from '@/store/maps/actions';
export  const useMapStore = () => {
    const store = useStore<StateInterface>()

    return {
        map: computed ( () => store.state.maps.map ),
        distance: computed ( () => store.state.maps.distance ),
        duration: computed ( () => store.state.maps.duration ),
        //mutations
        setMap: ( map: Mapboxgl.Map) => store.commit('maps/setMap', map),
        setPlacesMarkers: ( places: Feature[]) => store.commit('maps/setPlacesMarkers', places),
        //actions
        getRouteBetweenPoints: ( start: lngLat, end : lngLat) => store.dispatch('maps/getRouteBetweenPoints', { start, end}),
        //getters
        isMapReady: computed<boolean> ( () => store.getters['maps/isMapReady'])
    }
}